<script setup lang="ts">
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { useDevice } from '@modules/core/composables/device';
import { QA_TABLES } from '@modules/tables/constants';

import type { ITableRefreshProps } from './types';

defineProps<ITableRefreshProps>();

const { isMobile } = useDevice();
</script>

<template>
  <div v-data-qa-auto-id="'VTableRefresh'">
    <VIconButton
      v-data-test="{ el: QA_TABLES.refreshButton }"
      icon="pi-refresh"
      :size="isMobile ? undefined : 'large'"
      :loading="loading"
      :class="{ 'text-muted-color': isMobile }"
    />
  </div>
</template>
